module.exports = __webpack_public_path__ + "Cloud_Marketplace.47e09d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/portal_icons/Cloud_Marketplace.png
// module id = 714
// module chunks = 0